import axios from 'axios';
import konsole from "./konsole";
import AoUrl, { BASE_URL, stripePaymentConfirmationUrl } from './url';
import commonLib from '../control/commonLib';
import { encryptPayload, decryptPayload, encryptGetUrl } from "../../src/crypto/aesGCM";
const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION_ENABLED;
 
// axios.defaults.timeout = 15000;  
axios.defaults.baseURL = BASE_URL;
// axios.defaults.headers.post['Content-Type'] = 'application/json;text/html;charset=utf-8';
// axios.defaults.headers.post['Accept'] = 'application/json, text/plain, */*';
// axios.defaults.headers.post['origin'] =



const invoke = async (url, method, body, cancel) => {
    if(cancel){
        cancel();
    }
    try {
      konsole.log('URL: ' + url);
      konsole.log('method:' + method);
      konsole.log(((method == "POST") ? "body" : 'params') + JSON.stringify(body));
      let token = sessionStorage.getItem("AuthToken");
   
   
      konsole.log("token ", `Bearer ${token}`);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
   
      // ENCRYPTION - for POST/PUT/PATCH/DELETE request bodies (skip FormData/file uploads)
      let requestBody = body;
      const upperMethod = (method || "").toUpperCase();
      if (upperMethod === "POST" || upperMethod === "PUT" || upperMethod === "PATCH" || upperMethod === "DELETE") {
        requestBody = (isEncryptionEnabled === "true" && !(body instanceof FormData))
          ? await encryptPayload(body)
          : body;
      }
   
      // ENCRYPTION - for GET request URL (params encrypted into a single `data` query param)
      let requestUrl = url;
      let requestParams = (upperMethod === "GET") ? body : null;
      if (upperMethod === "GET" && isEncryptionEnabled === "true") {
        // Use a throwaway origin only so `new URL` can parse a relative path.
        // We strip this origin back off afterwards so axios keeps using its baseURL
        // (which may include a path prefix like /LPL). Passing an absolute URL here
        // would bypass baseURL and drop that prefix, causing CORS/404 errors.
        const DUMMY_ORIGIN = "http://dummy.local";
        const urlObj = new URL(url, DUMMY_ORIGIN);
        if (body && typeof body === "object") {
          Object.keys(body)?.forEach((key) => {
            if (body[key] !== undefined && body[key] !== null) {
              urlObj.searchParams.append(key, body[key]);
            }
          });
        }
        const encryptedAbsolute = await encryptGetUrl(urlObj.toString());
        // Keep only path + query so axios prepends baseURL as usual
        const encryptedObj = new URL(encryptedAbsolute);
        requestUrl = encryptedObj.pathname + encryptedObj.search;
        requestParams = null; // params are now encrypted inside the `data` query param
      }
   
      const response = await axios({
        cancelToken: new axios.CancelToken(function executor(c) {
                cancel = c;
            }),
   
            method: method,
            url: requestUrl,
            params: (method === "GET") ? requestParams : null,
            data:
          method === "POST" || method === "PUT" || method === "DELETE"
            ? requestBody
            : null,
      });
   
      // RESPONSE DECRYPTION
      if (response?.data?.encrypted === true && isEncryptionEnabled === "true") {
        response.data = await decryptPayload(response.data);
      }
   
      return response;
    } catch(error){
        if(axios.isCancel(error)) {
            konsole.error('Request canceled', error.message);
        } else {
            konsole.error('Something went wrong: ', error.message)
        }
      // Re-throw so existing .catch()/await error handling in callers keeps working
      throw error;
    }
  };
 
 
// const invoke = (url, method, body, cancel) => {
 
//     if(cancel){
//         cancel();
//     }
 
//     try {
//         let token = sessionStorage.getItem("AuthToken");
 
//         konsole.log("token ", `Bearer ${token}`);
//         axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//         konsole.log('URL: '+url);
//         konsole.log('method:'+method);
//         konsole.log(((method === "POST")?"body": 'params')+JSON.stringify(body));
 
//         return axios({
//             cancelToken:new axios.CancelToken(function executor(c) {
//                 cancel = c;
//             }),
//             method:method,
//             url:url,
//             params:(method==="GET")?body:null,
//             data:(method==="POST" || method === "PUT")?body:null
//         });
//     }catch(error){
//         if(axios.isCancel(error)) {
//             konsole.error('Request canceled', error.message);
//         } else {
//             konsole.error('Something went wrong: ', error.message)
//         }
//     }
// };
 
const Services = {

    getLoggedInUser: async (userId, appState, loggedInUserId, roleId) => {
        let cancel;
        // let url = AoUrl.getAthenticatePath +`${userId}/${appState}/${loggedInUserId}/${roleId}/`;
        let url = AoUrl.getAthenticatePath + `?UserId=${userId}&AppState=${appState}&LoggenInId=${loggedInUserId}&RoleId=${roleId}`;
        let bookingSlot = {};

        return invoke(url, "GET", bookingSlot, cancel);
    },
    getExpirydatetime: async (loginUserId,roleId) => {
        let cancel;
        let url =AoUrl.getExpirydatetime +`/${loginUserId}/${roleId}`;
        let body = {};

        return invoke(url, "GET", body, cancel);
    },
    createAcademyUser: async (input) => {
        let cancel;
        let url = AoUrl.createAcademyUser;
        let body = input;

        return invoke(url, "POST", body, cancel);
    },
    getSubtenantDetail: async (subtenantId,isActive) => {
        let cancel;
        let url = AoUrl.getSubtenantDetailPath
        let body = {};
        body['subtenantId'] = subtenantId;
        // body['subtenantLogoUrl'] = subtenantLogoUrl;
        body['isActive'] = isActive;

        return invoke(url, "POST", body, cancel);
    },
    putUpgradeValidity: async (userValidityId,loginUserid,userId,userRoleId,roleId,expriedDate,createdBy) => {
        let cancel;
        let url = AoUrl.upGradeValidity
        let body = {};
        body['userValidityId'] = userValidityId;
        body['loginUserid'] = loginUserid;
        body['userId'] = userId;
        body['userRoleId'] = userRoleId;
        body['roleId'] = roleId;
        body['expriedDate'] = expriedDate;
        body['createdBy'] = createdBy;


        return invoke(url, "PUT", body, cancel);
    },
    postuserorderAddUserOrder:async(adduserobj)=>{
        let cancel;
        let url=AoUrl.postAddUserOrder;


        return invoke(url,"POST",adduserobj,cancel)
    },
    postLogUserout: async () => {
        let stateObj = commonLib.getObjFromStorage('stateObj');
        stateObj.roleId = stateObj ? JSON.parse(stateObj.roleId) : {};
        const userId = stateObj.userId;
        const appState = stateObj.appState;
        const loggenInId = stateObj.loggenInId;
        const roleId = stateObj.roleId[0].roleId;

        let cancel;
        let url = AoUrl.postLogUserout + `${userId}/${appState}/${loggenInId}/${roleId}`;
        let body = {};
        return invoke(url, "GET", body, cancel);
    },
    apiCallScripePaymentConfirmation: async ({ userEmail }) => {
        return new Promise((resolve, reject) => {
            let newformData = new FormData()
            newformData.append('user_email', userEmail);
            newformData.append('user_confirmation', 1);
            axios.post(stripePaymentConfirmationUrl, newformData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => {
                resolve("done");
                konsole.log('Response:', response.data);
            })
                .catch(error => {
                    resolve("err");
                    konsole.error('Error:', error);
                });
        })

    }
}

export default Services;
